module.exports = __webpack_public_path__ + "static/media/stepapp_logo.822fa373.png";